export default function () {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const widgetItems = data.items.length;

      if (widgetItems >= 1) {
        const widgetTitle = `
        <h2 aria-label="${data.items[0].Title} ${data.items[0].Description}">
          <span>${data.items[0].Title}</span>
          <span>${data.items[0].Description}</span>
        </h2>`;

        $(`#${widgetName} .card-widget-item`).each(function (x) {
          if (x == 0) {
            $(this).remove();
          } else {
            const url = data.items[x].URL;
            const linkContent = url
              ? `<a href='${url}' class="card-widget-item">${data.items[x].Title}</a>`
              : `<span class="card-widget-item void-link">${data.items[x].Title}</span>`;

            $(this).replaceWith(`
                <div class="ribbon-container">
                  <span class="ribbon-shape-left"></span>
                    ${linkContent}
                  <span class="ribbon-shape-right"></span>
                </div>`);
          }
        });
        $(`#${widgetName}`).prepend(widgetTitle);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
    showDescription: true,
    moreButton: false,
    buyNowButton: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    maxItemsVisible: 5,
    itemsPerPanel: 5,
    scriptPath: widgetOpts.scriptPath,
  });
}
